import React from 'react';

import SettingsGroup from 'components/Shared/SettingsGroup';
import { ContentSet } from 'components/Shared/Scaffolding';
import { TextButton } from 'components/Shared/Buttons';
import MarkerPreviewRow from 'components/MarkerSettings/MarkerPreviewRow';
import { CardWrapper, CardIcon, PreviewRow, PreviewDesc } from 'components/Shared/Cards';
import { GLYPHS } from 'components/Shared/Icon';

const MarkerPreview = ({
    markers,
    zoom,
    onAddClick,
    onEditClick,
    onHighlightClick,
    onDeleteClick,
    onInfoWindowClick,
    styleImageUrl,
    className,
    labelClassName,
    contentClassName,
}) => {
    const hasMarkers = markers && markers.length > 0;
    return (
        <SettingsGroup
            name="Markers"
            description="Add some custom markers to your map"
            className={className}
            labelClassName={labelClassName}
            contentClassName={contentClassName}
        >
            <ContentSet>
                {!hasMarkers && (
                    <CardWrapper onClick={onAddClick}>
                        <PreviewRow>
                            <CardIcon glyph={GLYPHS.MARKER_OUTLINE} />
                            <PreviewDesc hasPreview={false}>Add your first marker</PreviewDesc>
                            <CardIcon primary glyph={GLYPHS.CHEVRON_RIGHT} />
                        </PreviewRow>
                    </CardWrapper>
                )}
                {hasMarkers &&
                    markers.map((marker) => (
                        <MarkerPreviewRow
                            key={marker.id}
                            marker={marker}
                            zoom={zoom}
                            onEditClick={onEditClick}
                            onHighlightClick={onHighlightClick}
                            onDeleteClick={onDeleteClick}
                            onInfoWindowClick={onInfoWindowClick}
                            styleImageUrl={styleImageUrl}
                        />
                    ))}
                {hasMarkers && (
                    <TextButton outlined block onClick={onAddClick}>
                        Add a marker
                    </TextButton>
                )}
            </ContentSet>
        </SettingsGroup>
    );
};

export default MarkerPreview;
